module.exports = __webpack_public_path__ + "static/media/add-scopes.b1a9fb6a.gif";